import type { FaireProductEntity } from "../../entity_types/product";

export const p_thnfdbs5gj: FaireProductEntity = {
  token: "p_thnfdbs5gj",
  type: "product",
  name: "Pink Cupcake Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6b43bc47e3df58dddaec23149d6126f5ea6f112f7bb4001f0c5b7ba760091de4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a69a83d69749776117e4c2882e862653909b1370bb7636616d2e94c182a020ee.jpeg",
    "https://cdn.faire.com/fastly/4612c4651a4cea0c458aef51a38f1ebab925165628ab7d92b7d81f97c00fd8b5.jpeg",
    "https://cdn.faire.com/fastly/6ad31714522aae213dc71f3bb888f312c1107761205335e148faf7bc9bbb075f.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:35.066Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
